export default {
      id: "icon-book-usage",
      viewBox: "0 0 23.151 20.151",
      url: __webpack_public_path__ + "img/icons.svg#icon-book",
      toString: function () {
        return this.url;
      }
    }